import { useState } from 'react';
import { NavMenuTreeManager } from '@/components/rbac/NavMenuTreeManager';
import { cn } from '@/lib/utils';

type CatalogTab = 'platform' | 'tenant';

export function PermissionMenuPage() {
  const [tab, setTab] = useState<CatalogTab>('platform');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">权限与菜单</h1>
      </div>

      <div
        role="tablist"
        aria-label="菜单范围"
        className="inline-flex rounded-xl border border-white/10 bg-zinc-900/50 p-1"
      >
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'platform'}
          id="tab-platform"
          onClick={() => setTab('platform')}
          className={cn(
            'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
            tab === 'platform'
              ? 'bg-cyan-500/15 text-cyan-100 shadow-[0_0_20px_-8px_rgba(34,211,238,0.35)] ring-1 ring-cyan-500/25'
              : 'text-zinc-400 hover:bg-white/[0.05] hover:text-zinc-200',
          )}
        >
          运营后台
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'tenant'}
          id="tab-tenant"
          onClick={() => setTab('tenant')}
          className={cn(
            'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
            tab === 'tenant'
              ? 'bg-fuchsia-500/12 text-fuchsia-100 shadow-[0_0_20px_-8px_rgba(217,70,239,0.3)] ring-1 ring-fuchsia-500/25'
              : 'text-zinc-400 hover:bg-white/[0.05] hover:text-zinc-200',
          )}
        >
          租户门户
        </button>
      </div>

      {tab === 'platform' && (
        <div role="tabpanel" aria-labelledby="tab-platform" className="space-y-8">
          <NavMenuTreeManager scope="PLATFORM" accent="cyan" variant="embedded" />
        </div>
      )}

      {tab === 'tenant' && (
        <div role="tabpanel" aria-labelledby="tab-tenant" className="space-y-8">
          <NavMenuTreeManager scope="TENANT" accent="fuchsia" variant="embedded" />
        </div>
      )}
    </div>
  );
}
